import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AppInsightsService } from './services/app-insights.service';
import { GoogleAnalyticsService } from './services/google-analytics.service';

@Component({
  selector: 'app-recon',
  templateUrl: 'app.component.html',
  providers: [AppInsightsService],
})

export class AppComponent {
  title = 'app';
  sections: string = JSON.stringify([{
    name: 'Home',
    path: 'home',
    feature: 'home',
    subSection: [{ name: 'Welcome', path: 'welcome', feature: 'home' }],
  }, {
    name: 'Service Event Search',
    path: 'eventsearch',
    feature: 'MenuItemServiceEventSearch',
    subSection: null,
  }, {
    name: 'Deposit Confirmation',
    path: 'confirmdeposit',
    feature: 'MenuItemDeposits',
    subSection: null,
  }, {
    name: 'Remittance Entry',
    path: 'depositsearch',
    feature: 'UI::DepositSearch',
    subSection: null,
  },
  ])
  constructor(private appInsightsService: AppInsightsService, private googleAnalyticsService: GoogleAnalyticsService, private router: Router) {
    appInsightsService.logPageView('Application initialized');
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        googleAnalyticsService.logPageView(event);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts